import { Fragment } from 'react';
// @ts-expect-error untyped import
import ResultsSection from 'ecosystem-marketplace-core/components/storefront/ResultsSection';
/* @ts-expect-error module is untyped */
import ResultsSectionHeader from 'ecosystem-marketplace-core/components/storefront/ResultsSectionHeader';
import LoadingWrapper from 'marketplace-ui-common/layout/components/LoadingWrapper';
import ResultsGrid from '../../components/storefront/results/ResultsGrid';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ResultsGridSection({
  onResultClick,
  requestState,
  results,
  section,
  title
}) {
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx(ResultsSection, {
      "data-test-id": "results-grid-section",
      style: {
        display: 'flex',
        justifyContent: 'left'
      },
      children: /*#__PURE__*/_jsxs(UIFlex, {
        direction: "column",
        children: [/*#__PURE__*/_jsx(ResultsSectionHeader, {
          "aria-level": 1,
          className: "is--heading-2",
          children: title
        }), /*#__PURE__*/_jsx(LoadingWrapper, {
          requestStatus: requestState,
          children: /*#__PURE__*/_jsx(ResultsGrid, {
            className: "vr-hidden",
            onResultClick: onResultClick,
            requestState: requestState,
            results: results,
            section: section
          })
        })]
      })
    })
  });
}